import { EXPECTED_CONNECT_ERROR_PATTERNS } from './constants'

export const getIsExpectedConnectError = (message: string): boolean =>
  EXPECTED_CONNECT_ERROR_PATTERNS.some(pattern => pattern.test(message))
